import { api } from '@/services';
import Vue from 'vue';
import Vuetify from '@/plugins/vuetify';

export default {
  async fetchPrefaturamento({ commit }, payload) {
    const { codigoProcesso, codigoFilial, codigoDi, codigoInvoice } = payload;
    const response = await api.get(`/processo/conferencia/processo/${codigoProcesso}/filial/${codigoFilial}/codigoDI/${codigoDi}/invoice/${codigoInvoice}/conferencia-pre-faturamento`);
    commit('SET_PRE_FATURAMENTO_COMPARATIVO_PRODUTO_DI', response.data.comparativoProdutoDI);
    commit('SET_PRE_FATURAMENTO_PRODUTOS_PROCESSO', response.data.produtosProcesso);
    commit('SET_PRE_FATURAMENTO_FINANCEIRO_PAGAR', response.data.financeiroPagar);
    commit('SET_PRE_FATURAMENTO_CUSTOS_EMISSAO_NF', response.data.custosEmissãoNF);
    return response.data.informacoesProcesso[0];
  },
  async fetchProcessoEventoPreFaturamento({ commit }, payload) {
    const { codigoProcesso, codigoFilial } = payload;
    const response = await api.get(`/processo/conferencia/processo/${codigoProcesso}/filial/${codigoFilial}/possui-evento-conferencia-pre-faturamento`);
    commit('SET_PRE_FATURAMENTO_EXIBIR', response.data);
  },
  async baixarPDFConferenciaPreFaturamento(_, payload) {
    try {
      const { codigoProcesso, codigoFilial } = payload;
      const base64 = await api.get(
        `/processo/conferencia/processo/${codigoProcesso}/filial/${codigoFilial}/download`,
      );

      const binaryString = window.atob(base64.data); // Decodifica a string base64
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      const arrayBuffer = bytes.buffer;

      const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `conferencia-pre-faturamento-processo-${codigoProcesso}.pdf`); // Especificar o nome do arquivo com a extensão
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      Vue.$toast.success(
        Vuetify.framework.lang.t('$vuetify.documentoBaixadoSucesso'),
      );
    } catch (e) {
      Vue.$toast.clear();
      Vue.$toast.error(
        Vuetify.framework.lang.t('$vuetify.erroBaixarDocumento'),
      );
    }
  },
};
